import { REDUCE_CRM_WEB_CONFIGURATION } from '../../constants/actions/CRMWebConfiguration';

export default function CRMWebConfiguration(payload) {
    return {
        type: REDUCE_CRM_WEB_CONFIGURATION,
        payload,
    };
}
